import { Api } from 'src/common';

const endpoint = `signedMerchantAgreements`;

type SignedMerchantAgreement = {
  signedAgreement: string;
};

export async function requestSignedMerchantAgreement(
  base64Image: string,
): Promise<{ error?: string; signedAgreementPDF?: string }> {
  try {
    const { response } = await Api.post<SignedMerchantAgreement>(endpoint, {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ signatureCapture: base64Image }),
    });

    return { signedAgreementPDF: response.signedAgreement };
  } catch (error) {
    return { error: 'An error occurred while processing your request.' };
  }
}
